/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileMemberPatch } from '../../models/profile-member-patch';
import { ProfileMemberResponse } from '../../models/profile-member-response';

export interface PatchProfileMember$Params {
  id: number;

/**
 * Id of member, see id in ProfileMemberResponse.
 */
  memberId: number;
      body: ProfileMemberPatch
}

export function patchProfileMember(http: HttpClient, rootUrl: string, params: PatchProfileMember$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileMemberResponse>> {
  const rb = new RequestBuilder(rootUrl, patchProfileMember.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('memberId', params.memberId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileMemberResponse>;
    })
  );
}

patchProfileMember.PATH = '/rest/profile/{id}/members/{memberId}';
